export default ({ props }) => {
  return {
    button: {
      marginRight: '12px',
    },
    tip: {
      color: '#9B9B9B',
      cursor: 'pointer',
    },
    controlsBlock: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
    },
  }
}
